import { render, staticRenderFns } from "./BiddingProcess.vue?vue&type=template&id=8d2f756e&"
import script from "./BiddingProcess.vue?vue&type=script&lang=ts&"
export * from "./BiddingProcess.vue?vue&type=script&lang=ts&"
import style0 from "./BiddingProcess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports